import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Flex,
  HStack,
  Link,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { hasCookieConsent, setCookieConsent } from '../utils/cookieConsent';

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const bg = useColorModeValue('white', 'gray.800');
  const border = useColorModeValue('gray.200', 'gray.600');

  useEffect(() => {
    setVisible(!hasCookieConsent());
  }, []);

  if (!visible) return null;

  const accept = (analytics: boolean) => {
    setCookieConsent(analytics);
    setVisible(false);
  };

  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      zIndex={1400}
      bg={bg}
      borderTop="1px solid"
      borderColor={border}
      boxShadow="lg"
      py={4}
    >
      <Container maxW="6xl">
        <Flex
          direction={{ base: 'column', md: 'row' }}
          align={{ base: 'stretch', md: 'center' }}
          justify="space-between"
          gap={4}
        >
          <Text fontSize="sm" color="gray.600" maxW="3xl">
            We use essential cookies to keep you signed in and optional analytics cookies to improve the
            product. See our{' '}
            <Link as={RouterLink} to="/privacy#cookies" color="blue.500">
              Cookie Policy
            </Link>{' '}
            for details.
          </Text>
          <HStack spacing={3} flexShrink={0}>
            <Button size="sm" variant="outline" onClick={() => accept(false)}>
              Essential only
            </Button>
            <Button size="sm" colorScheme="blue" onClick={() => accept(true)}>
              Accept all
            </Button>
          </HStack>
        </Flex>
      </Container>
    </Box>
  );
};

export default CookieConsent;
